import React from "react";
import styles from "./InterviewsSection.module.scss";
import interviewImage from "../../../assets/images/interview.jpg";

const InterviewsSection = () => {
  return (
    <div className={styles.interviewsSectionContainer}>
      <h1 className={styles.mainTitle}>Interviews</h1>

      <div className={styles.interviewList}>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={interviewImage} alt="The Title Of The Interview" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Interview">
              The Title Of The Interview
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={interviewImage} alt="The Title Of The Interview" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Interview">
              The Title Of The Interview
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.image}>
            <img src={interviewImage} alt="The Title Of The Interview" />
          </div>
          <div className={styles.info}>
            <h2 className={styles.title} title="The Title Of The Interview">
              The Title Of The Interview
            </h2>
            <div className={styles.date}>Nov 24, 2024</div>
            <p className={styles.desc}>
              Contrary to popular belief, Lorem Ipsum is not simply random text.
              It has roots in a piece of classical Latin literature from 45
              BC...
              <span>Read more</span>
            </p>
          </div>
        </div>
      </div>

      <div className={styles.viewAllCentered}>View All</div>
    </div>
  );
};

export default InterviewsSection;
